module.exports = __webpack_public_path__ + "img/marsLoading.ba192472.gif";